import React from 'react'
import UserInvitationSuccess from '../components/userInvitation/UserInvitationSucces'


export default function UserInvitationSuccessPage({ code, accessPin, schedules, isPermanent }) {
  return (
    <UserInvitationSuccess
      code={code}
      accessPin={accessPin}
      schedules={schedules}
      isPermanent={isPermanent}
    ></UserInvitationSuccess>
  )
}
